import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  © 2025 ON24 AS

  <span style="color:#85c1dc;">**FI:**</span>
  © 2025 On24 Sisustus OY

  <span style="color:#85c1dc;">**RU:**</span>
  © 2025 ON24 AS
*/
/* @__NO_SIDE_EFFECTS__ */
const m1256 = msg(
  mf`© 2025 ON24 AS`,
  mf`© 2025 On24 Sisustus OY`,
  mf`© 2025 ON24 AS`,
)

export { m1256 as 'w.footer.copyright' }